<script setup>
import { ref, onUnmounted } from "vue";

const emit = defineEmits(['timeIsUp', 'tick']);

const props = defineProps({
  secs: { type: Number, required: true }
});

let timer = ref(props.secs);

emit('tick', { remaining: timer.value, total: props.secs });

const interval = setInterval(() => {
  if (timer.value === 0) {
    emit("timeIsUp");
    clearInterval(interval);
  } else {
    timer.value--;
    emit('tick', { remaining: timer.value, total: props.secs });
  }
}, 1000);

onUnmounted(() => clearInterval(interval));
</script>